/* eslint-disable compat/compat */
class ProductBis extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.listeners.add(this.els.form.element, 'submit', e => {
      e.preventDefault()
      this.onFormSubmission()
    })
  }

  onFormSubmission () {
    const variantId = this.els.form.element.dataset.variantId

    const emailAddress = this.els.email.element.value

    this.KlaviyoSubmission(variantId, emailAddress)
  }

  async KlaviyoSubmission (variantId, emailAddress) {
    const request = await fetch(
      'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
      {
        method: 'POST',
        headers: {
          accept: 'application/json, text/plain, */*',
          'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: new URLSearchParams({
          a: window.theme.klaviyo.apiKey,
          email: emailAddress,
          variant: variantId,
          platform: 'shopify',
        }),
      },
    )

    const response = await request.json()

    if (response.status === 400) {
      console.error(response)
      this.throwError()
    } else if (response.success) {
      this.showSuccess()
    }
  }

  showSuccess () {
    this.els.success.element.setAttribute('aria-hidden', false)
    this.els.content.element.setAttribute('aria-hidden', true)
  }
}

if (!customElements.get('product-bis')) {
  customElements.define('product-bis', ProductBis)
}
